module.exports = __webpack_public_path__ + "89adf2b0737e6987f658c9b0170d3837.svg";